
import { ElLoading } from "element-plus";

const columnList: Array<column> = [
    {
        prop: "code",
        label: "车牌号码",
        width: 66,
    },
    {
        prop: "vin",
        label: "车架号",
        width: 66,
    },
    {
        prop: "serve_num",
        label: "服务次数",
        width: 66,
        sortable: true,
    },
    {
        prop: "total_output",
        label: "产值合计",
        width: 66,
        sortable: true,
    },
    {
        prop: "model_name",
        label: "品牌车型",
        width: 66,
    },
    {
        prop: "repair_unit_name",
        label: "所属单位",
        width: 66,
    },
    {
        prop: "user_id",
        label: "绑定会员",
        width: 66,
    },
    {
        prop: "serve_time",
        label: "最近服务",
        width: 66,
    },
    {
        prop: "nickname",
        label: "接车人",
        width: 66,
    },
    {
        prop: "send_for_repair",
        label: "送修人",
        width: 66,
    },
    {
        prop: "phone",
        label: "手机",
        width: 66,
    }
];
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { carDueExport, carRankExport, getPurchaseTable, getSupplierList, carRankList } from "@/api/shenghuiHttp";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "CarRank",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["车辆产值排行"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            headClass = inject("headClass"),
            shortcuts = ref([
                {
                    text: "最近一周",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近一个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近三个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    })(),
                },
            ] as any),
            screenParameter = ref({
                time: '',
                page: currentPage.value,
                pagesize: pageSize.value,
                start_time: null,
                end_time: null,
                search: '',
                sort_field: '',
                sort_type: ''
            } as any),
            handleSortChange = ({ prop, order }: any): void => {
                if (order) {
                    screenParameter.value.sort_field = prop;
                    screenParameter.value.sort_type = order === 'ascending' ? 'asc' : 'desc';
                } else {
                    screenParameter.value.sort_field = '';
                    screenParameter.value.sort_type = '';
                }
                getTableData();
            },
            screenChange = (e: any, key: any): void => {
                if (e && key) {
                    screenParameter.value.start_time = e[0]
                        ? new Date(e[0]).getTime()
                        : null;
                    screenParameter.value.end_time = e[1]
                        ? new Date(e[1]).getTime()
                        : null;
                }
                getTableData();
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });

                carRankExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(() => {
                    loading.close();
                });
            },
            getTableData = (): void => {
                loading.value = true;
                let data = { ...screenParameter.value, page: currentPage.value, pagesize: pageSize.value };
                Object.keys(data).forEach(key => {
                    if (data[key] == null) {
                        delete data[key]
                    }
                })
                delete data.time;
                carRankList(data).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            selectChange = (e: number): void => {
                getTableData();
            };

        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            shortcuts,
            total,
            pageSize,
            currentPage,
            handleSizeChange,
            handleCurrentChange,
            screen,
            screenParameter,
            selectChange,
            screenChange,
            exportChange,
            handleSortChange
        };
    },
});
